/**
 * @desc        Planning Event Reducer
 * @version     1.1 - 1 Feb 22 */

import * as actionTypes from '../../actions/action-types.js'

const initialState = {
    lastFetch: 0,
    loading: false,
}

const planningEvents = (state = initialState, action) => {
    const { data, type } = action
    switch (type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.PE_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lastFetch: Date.now(),
                data: data,
            }
        case actionTypes.PE_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.PE_REQUEST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                lastError: Date.now(),
            }
        case actionTypes.PE_CACHE:
            return {
                ...state,
                loading: false,
            }
        default: {
            return state
        }
    }
}
export default planningEvents
